export default __webpack_public_path__ + "static/media/wDress_1_p2.54b22560.jpeg";